import axios from 'axios'
import store from '../store'
import { getToken, setToken, getTenantCode } from '@/utils/auth'
import { isSuccess } from '@/utils/util'
import { refreshToken } from '@/api/admin/login'
import { Message } from 'element-ui'
import errorCode from '@/const/errorCode'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
const whiteList = ['/auth/authentication/removeToken']// 白名单

// 超时时间
const instance = axios.create({
  // baseURL: baseURL,
  timeout: 60000,
  withCredentials: true
})

// 跨域请求，允许保存cookie
NProgress.configure({ showSpinner: false })// NProgress Configuration

// 是否正在刷新token标记
let isRefreshing = false
// refresh 次数阈值
let refreshCnt = 0
// 缓存所有请求(重试队列、每一项都是待执行的函数)
let requests = []

// 封装刷新token的方法
function doRefreshToken(config) {
  async function refresh() {
    const token = getToken()
    // 如果没有 token，直接返回，不刷新
    if (!token) {
      return Promise.reject(new Error('No token'))
    }
    if (!isRefreshing) {
      isRefreshing = true
      refreshCnt++
      if (refreshCnt > 3) {
        // 刷新次数过多时不显示错误提示，静默失败
        console.warn('Token refresh count exceeded')
        refreshCnt = 0
        return
      }
      try {
        refreshToken(token).then(response => {
          setToken(response.data.result.token)
          store.commit('SET_TOKEN', response.data.result.token)
          requests.forEach((cb) => cb())
          requests = []
          refreshCnt = 0
        }).catch(err => {
          console.log(err, 'Token refresh failed')
          refreshCnt = 0
        })
      } catch (error) {
        console.error('Token refresh error:', error)
        refreshCnt = 0
      } finally {
        isRefreshing = false
      }
    }
  }

  refresh()

  return new Promise((resolve) => {
    requests.push((_) => {
      config.headers['Authorization'] = getToken()
      resolve(instance(config))
    })
  })
}

// HTTP request拦截
instance.interceptors.request.use(config => {
  NProgress.start() // start progress bar
  if (store.getters.token && whiteList.indexOf(config.url) === -1) {
    const authorization = config.headers['Authorization']
    if (authorization === undefined || authorization.indexOf('Basic') === -1) {
      config.headers['Authorization'] = getToken() // 让每个请求携带token
    }
  }
  // 增加租户编号请求头
  const tenantCode = config.headers['Tenant-Code']
  if (tenantCode === undefined) {
    config.headers['Tenant-Code'] = getTenantCode()
  }
  return config
}, error => {
  return Promise.reject(error)
})

// HTTP response拦截
instance.interceptors.response.use(data => {
  NProgress.done()
  // 请求失败，弹出提示信息
  if (!isSuccess(data.data)) {
    const { code, message, result } = data.data
    // token失效
    if (result === 401) {
      return doRefreshToken(data.config)
    }
    const errMsg = errorCode[String(code)] || message || errorCode['default']
    Message({ message: errMsg, type: 'error' })
  }
  return data
}, error => {
  NProgress.done()
  if (error.response) {
    // 如果是未登录状态（没有 token）的 401/500 错误，不显示错误提示
    const token = getToken()
    if (!token && (error.response.status === 401 || error.response.status === 500)) {
      console.log('Unauthenticated request, skipping error message')
      return Promise.reject(error)
    }
    
    // 其它错误则弹出提示
    const { code, msg } = error.response.data
    const errMsg = errorCode[String(code)] || msg || errorCode['default']
    Message({ message: errMsg, type: 'error' })
  }
  return Promise.reject(new Error(error))
})

export default instance



// WEBPACK FOOTER //
// ./src/router/axios.js